const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnelLvl2Disable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 344.23 91.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283,77.68S229.87,88.32,172.12,88.32c-56,0-108.52-10.64-108.52-10.64l-32.39-63s70.88,11.14,141,11.14c67.77,0,140.78-11,140.78-11Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.92,3.27c-84.25,0-140.71,11.4-140.71,11.4A927.68,927.68,0,0,0,172.53,26C245,26,313,14.82,313,14.82S249.88,3.27,171.92,3.27Z",
    style: {
      fill: "#2d938c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,77.68S229.87,88.32,172.12,88.32c-56,0-108.52-10.64-108.52-10.64l-32.39-63s70.88,11.14,141,11.14c67.77,0,140.78-11,140.78-11Z",
    style: {
      fill: "#48b4ae"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "107.59 85.99 76.29 84.39 47.29 15.01 88.49 17.5 107.59 85.99",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.04 85.99 291.59 80.06 323.58 12.57 262.13 17.5 243.04 85.99",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelLvl2Disable);
export default __webpack_public_path__ + "static/media/funnel-lvl2-disable.87f85e06aec52d3a1787c8b5fab7b4f2.svg";
export { ForwardRef as ReactComponent };